import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {ModuloHRAPI} from "../../../../../api/ModuloHR/ModuloHRAPI";
import FuxOffsetPaginator from "../../../../../components/BaseComponents/FuxOffsetPaginator/FuxOffsetPaginator";
import TimeoffRequestListItem from "./TimeoffRequestListItem";
import TimeoffRequestsNewRequestPage from "./TimeoffRequestsNewRequestPage";
import TimeoffRequestDetailPage from "./TimeoffRequestDetailPage";
import ModalPortalHOC from "../../../../../components/BaseComponents/ModalPortalHOC";

export default class TimeoffRequestsPermessiTab extends React.Component {
    constructor(props) {
        super(props);
        const firstStaffId = this.getDefaultStaffId(props.staffList);
        this.state = {
            selectedStaffId: firstStaffId,
            newRequestOpen: false,
            detailRequest: null
        };
        this.paginatorRef = React.createRef();
    }

    getDefaultStaffId = staffList => {
        if (!staffList || !staffList.length) return null;
        return staffList[0].id_dipendente || null;
    }

    handleNewRequestOpen = _ => this.setState({newRequestOpen: true});
    handleNewRequestClose = _ => this.setState({newRequestOpen: false});
    handleDetailClose = _ => this.setState({detailRequest: null});

    resetPaginator = _ => {
        if (this.paginatorRef.current && this.paginatorRef.current.reset) {
            this.paginatorRef.current.reset();
        }
    }

    handlePageRequest = page => ModuloHRAPI.TimeoffRequests.pagination(this.props.staffList.map(d => d.id_dipendente), page);


    handleDeleteRequest = item => {
        return ModuloHRAPI.TimeoffRequests.delete(item.request_id)
            .then(message => {
                this.resetPaginator();
                return message;
            });
    }

    handleRequestCreated = staffId => {
        const selectedStaffId = staffId || this.state.selectedStaffId;
        this.setState({newRequestOpen: false, selectedStaffId: selectedStaffId}, this.resetPaginator);
    }

    handleRequestOpen = item => {
        const staff = (this.props.staffList || []).find(s => s.id_dipendente === this.state.selectedStaffId);
        this.setState({detailRequest: {request: item, staff: staff}});
    }

    renderItem = (item, index) => {
        const staff = (this.props.staffList || []).find(s => s.id_dipendente === this.state.selectedStaffId);
        return (
            <TimeoffRequestListItem
                key={item.request_id || index}
                item={item}
                staff={staff}
                onOpen={this.handleRequestOpen}
            />
        );
    }

    renderEmptyPage = _ => {
        return (
            <div className={"container text-center text-muted py-4"}>
                Non ci sono richieste di permesso.
            </div>
        );
    }

    render() {
        return (
            <Fragment>
                <div className={"container py-3 text-right"}>
                    <button
                        type={"button"}
                        className={"btn btn-primary"}
                        onClick={this.handleNewRequestOpen}
                    >
                        Nuova richiesta
                    </button>
                </div>

                <div className={"container pb-4"}>
                    <FuxOffsetPaginator
                        ref={this.paginatorRef}
                        onPageRequest={this.handlePageRequest}
                        onItemRender={this.renderItem}
                        onEmptyPage={this.renderEmptyPage}
                        classItemsContainer={"list-group"}
                        visiblePagesCount={5}
                    />
                </div>
                <ModalPortalHOC>
                    {
                        this.state.newRequestOpen &&
                        <TimeoffRequestsNewRequestPage
                            staffList={this.props.staffList}
                            active={this.state.newRequestOpen}
                            onDismiss={this.handleNewRequestClose}
                            onRequestCreated={this.handleRequestCreated}
                        />
                    }

                    {
                        this.state.detailRequest &&
                        <TimeoffRequestDetailPage
                            staff={this.state.detailRequest.staff}
                            request={this.state.detailRequest.request}
                            active={!!this.state.detailRequest}
                            onDismiss={this.handleDetailClose}
                            onDelete={this.handleDeleteRequest}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        );
    }
}

TimeoffRequestsPermessiTab.propTypes = {
    staffList: PropTypes.array
};
